module.exports = __webpack_public_path__ + "img/longOnly_strategy_graphics.5adbbfa3.png";